import { getCurrencySymbol } from '@utils/utils';

import {
  DiscountedPricePackageContainer,
  OriginalPricePackageContainer,
} from './styled';
export type PriceFormat = 'discount' | 'normal' | 'landing' | 'payment';

const toLocalFormat = (price: number, local = 'tr-TR') =>
  (+price.toFixed(2)).toLocaleString(local);
export const getNumberParts = (price: number, local = 'tr-TR') => {
  const [whole = '0', decimals = '00'] = toLocalFormat(price, local).split(',');
  return [whole, decimals.padEnd(2, '0')];
};
interface DiscountedPackagePriceProps {
  price?: number;
  currency?: string;
  size?: number;
  noLine?: boolean;
  className?: string;
  discountedPrice?: number;
}
const DiscountedPackagePrice = ({
  price,
  currency,
  size = 12,
  noLine,
  className,
  discountedPrice,
}: DiscountedPackagePriceProps) => {
  if (price === undefined) return null;
  if (discountedPrice === undefined) return null;
  const [whole, decimals] = getNumberParts(price);
  const [wholes, discount] = getNumberParts(discountedPrice);

  return (
    <div className={className || ''}>
      <OriginalPricePackageContainer size={size} noLine={noLine}>
        {`${whole},${decimals} ${getCurrencySymbol(currency)}`}
      </OriginalPricePackageContainer>
      <br />
      <DiscountedPricePackageContainer size={size}>
        {`${wholes},${discount} ${getCurrencySymbol(currency)}`}
      </DiscountedPricePackageContainer>
    </div>
  );
};

export default DiscountedPackagePrice;
